<template>
  <div class="orm-mb-32 orm-col-xs-12 orm-carlist" v-if="filter">
    <div class="orm-row center-xs">
      <div
        class="orm-col-xs-12 orm-col-sm-12 orm-col-md-4 orm-mb-8 orm-mb-md-0"
      >
        <div
          class="orm-background--cta2 orm-py-24 orm-px-8 orm-px-sm-24 orm-h100"
        >
          <Slider v-if="images" :images="images" :autoplay="true" />
          <div v-else :style="{ paddingTop: '75%' }"></div>
          <div class="text-center orm-mt-8">
            {{ i18n("cargroup/color") || "Farbe" }}: {{ data.color }}
          </div>
          <div v-if="data.pdf_url" class="text-center orm-mt-8">
            {{ i18n("cargroup/equipment_details") || "Ausstattungsdetails" }}:
            <a :href="data.pdf_url" target="_blank">
              {{ i18n("cargroup/show_equipment_details") || "PDF anzeigen" }}
            </a>
          </div>
        </div>
      </div>
      <div class="orm-col-xs-12 orm-col-md-8">
        <div
          class="orm-background--cta2 orm-py-24 orm-py-sm-40 orm-px-8 orm-px-sm-24 orm-row orm-h100 no-margin -orm-ml-md-4"
        >
          <div
            class="orm-cartitle orm-col-xs-12 orm-col-sm-12 orm-col-md-8 orm-col-lg-8 orm-pr-md-24"
          >
            <h2 class="orm-headline__h2 orm-headline__h2--list">
              {{ stripHTML(data["vehicle_name"]) }}
            </h2>
            <div class="orm-mb-8">
              {{ stripHTML(data.vehicle_group.text_web) }}
              <span v-if="data.fuel_type"> - {{ data.fuel_type }} </span>
              <span v-if="data.features.find((item) => item.id === 'AT')">
                -
                {{ data.features.find((item) => item.id === "AT").description }}
              </span>
            </div>

            <div class="orm-carequip">
              <p class="orm-equip__txt__icons">
                <span
                  class="orm-mr-8 orm-inlineBlock"
                  v-for="feat in data.features.slice(0, 5)"
                  :key="feat.id"
                  >{{ feat.description }}
                </span>
              </p>
              <p>
                {{ i18n("cargroup/catalogueprice") || "Brutto-Listenpreis" }}:
                {{ convertCurrency(data.price) }}
              </p>
              <!-- <p class="orm-equip__txt__freemiles" v-if="car.price">
            {{ car.price.description2 }}
          </p> -->
            </div>
            <!-- <div
          class="orm-cardescription"
          v-html="data.vehicle_group[env.VUE_APP_RESERVATION_CARTEXT]"
        ></div> -->
          </div>
          <div
            class="orm-col-xs-12 orm-col-md-12 orm-col-lg-4 text-right orm-pr-8 orm-pt-1 bottom-self-md"
            v-if="abolength"
          >
            <div class="orm-carprice">
              <div
                v-if="data.available_from"
                class="orm-price__txt__surtitle--abo orm-color--red"
              >
                {{ i18n("cargroup/avaiableat") || "Verfügbar ab" }}
                {{ formateDate(data.available_from, "dd.mm.yyyy") }}
              </div>
              <div v-else class="orm-price__txt__surtitle--abo orm-color--blue">
                {{ i18n("cargroup/avaiablenow") || "Sofort Verfügbar" }}
              </div>
              <p class="orm-price__txt__surtitle--abo">
                {{ i18n("general/montly") || "Monatlich" }}
                {{ i18n("cargroup/unitafter") }}:
              </p>

              <p class="orm-price__txt--abo" v-if="data.prices">
                <span style="white-space: nowrap">
                  {{
                    convertCurrency(
                      showNettoPrice
                        ? data.prices.find((x) => x.months == abolength[0])
                            .price
                        : data.prices.find((x) => x.months == abolength[0])
                            .price_with_tax
                    )
                  }}</span
                >
              </p>
              <p
                class="orm-price__txt__subtitle--abo orm-nowrap orm-mb-32"
                v-if="data.prices"
              >
                <span v-if="showNettoPrice">{{
                  i18n("step2/zzgl") || "netto zzgl."
                }}</span>
                <span v-else>
                  {{ i18n("step2/incl") || "inkl." }}
                  {{
                    convertCurrency(
                      data.prices.find((x) => x.months == abolength[0]).tax
                    )
                  }}
                  {{
                    i18n("general/ust") ||
                      "Ust." ||
                      tarif.end_positions[1].description
                  }}
                </span>
                <span v-if="showNettoPrice">
                  {{
                    i18n("general/BusinessOnly") || "| Nur für Gewerbe"
                  }}</span
                >
              </p>
              <button
                class="orm-button__cta outline wide"
                @click="getCars(car)"
              >
                {{ i18n("cargroup/select") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import { convertCurrency, formateDate } from "@/constants/formater";
import { routeToSteps } from "@/constants/getRoutes";

import Slider from "@/components/ui/image-slider.vue";

import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";

export default defineComponent({
  name: "car-list-search-abo",
  components: {
    Slider,
  },
  emits: ["openSearchTarif"],
  mixins: [i18n, stripHTML],
  data() {
    return {
      car: Object,
      images: null,
      showSearch: false,
      station: store.getters["userSession/GET_STATION"],
      selectedStation: null,
      env: process.env,
      abolength: null,
      showNettoPrice: false,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
    stations: Object,
  },
  setup() {
    return {
      convertCurrency,
      formateDate,
      routeToSteps,
    };
  },
  async mounted() {
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );

    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }
    this.car = await this.data.vehicle_group;

    //{ image: this.data.images.interior[0].url }
    const images = [];
    this.data.images.exterior.forEach((element) => {
      images.push({ image: element.url });
      // console.log(element);
    });
    this.data.images.interior.forEach((element) => {
      images.push({ image: element.url });
      // console.log(element);
    });
    this.images = images;
    this.abolength = store.getters["reservation/GET_SELECTEDABO"];
  },
  methods: {
    openSearch() {
      this.$emit("openSearchTarif", this.car.id);
    },
    async lazyload() {
      this.images = this.car.images;
    },
    // async setCarGroup(car) {
    //   await store.dispatch("userSession/SET_VEHICLEID", car.id);
    //   store.dispatch("userSession/SET_CARGROUP", car.vehicle_id.id).then(() => {
    //     store
    //       .dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif)
    //       .then(() => {
    //         if (this.isOffer) buildDataLayer("view_promotion", {}, null);
    //         this.$router.push({ name: "Reservation_Step2" });
    //       });
    //   });
    // },
    async getCars() {
      // console.log(this.data);
      // await store.dispatch("offers/SELECT_OFFER", "ABO");
      await store.dispatch("userSession/SET_VEHICLE", this.data);
      store
        .dispatch("userSession/SET_CARGROUP", this.data.vehicle_group.id)
        .then(() => {
          store.dispatch("reservation/DELETE_TARIF");
          store.dispatch("stations/SET_OPENINGTIMES").then(() => {
            store
              .dispatch("reservation/CALCULATE_PRICE", {
                id: this.data.vehicle_group.id,
                extras: false,
                vehicle_id: this.data.id,
              })
              .then((tarif) => {
                // console.log(tarif);
                if (!tarif.main_rates) return;
                // console.log(tarif.main_rates.length);
                if (tarif.main_rates.length == 0) {
                  // const cartype = {};
                  // cartype[this.car["vehicle_category"][0]["id"]] = true;
                  // store.dispatch("userSession/SET_CARCATEGORY", cartype);
                  // if (process.env.VUE_APP_STANDALONE == "true") {
                  //   this.$router.push({ name: "Reservation_Step1" });
                  // } else {
                  //   window.location.href =
                  //     process.env.VUE_APP_BASE_URL +
                  //     process.env.VUE_APP_RESERVATION_PATH +
                  //     process.env.VUE_APP_RESERVATION_PATH_STEP1;
                  // }
                } else {
                  store
                    .dispatch("reservation/SET_RESERVATION_TARIFS", tarif)
                    .then(() => {
                      routeToSteps(this, 2);
                    });
                }
              });
          });
        });
    },
  },
});
</script>
